module.exports = __webpack_public_path__ + "static/media/hu.0d7409f8.svg";